module.exports = __webpack_public_path__ + "static/media/carousel5.a5f9474a.jpeg";